import {
  SET_DEVICE_INFO,
  FETCH_DEVICE_SYSTEM_ID_REQUEST,
  FETCH_DEVICE_SYSTEM_ID_SUCCESS,
  FETCH_DEVICE_SYSTEM_ID_FAILURE,
} from "./actions.type";
import { DeviceInfoState, DeviceInfoActions } from "./types";

const initialState: DeviceInfoState = {
  pending: false,
  deviceInfo: null,
  systemID: "",
  error: null,
};

export default (state = initialState, action: DeviceInfoActions): DeviceInfoState => {
  switch (action.type) {
    case SET_DEVICE_INFO:
      return {
        ...state,
        deviceInfo: action.payload,
      };
    case FETCH_DEVICE_SYSTEM_ID_REQUEST:
      return {
        ...state,
        pending: true,
      };
    case FETCH_DEVICE_SYSTEM_ID_SUCCESS:
      return {
        ...state,
        pending: false,
        deviceInfo: action.payload,
        error: null,
      };
    case FETCH_DEVICE_SYSTEM_ID_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    default:
      return {
        ...state,
      };
  }
};
